import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

import './card.scss';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const Card: FC<CardProps> = ({ className, ...props }) => (
  <div className={classNames('card flex flex-col bg-white border-gray-300 overflow-hidden', className)} {...props} />
);
